<template>
  <div class="container-fluids">
    <div>
      <h5 v-if="title">{{ title }}</h5>

      <div class="form-wrapper full" v-for="field in fields" :key="field.key">
        <div v-if="field.type === 'boolean'">
          <base-checkbox :disabled="isDisabled" v-model="config[field.key]" class="mb-0">
            <span class="form-control-label">
              {{ field.label }}
            </span>
          </base-checkbox>
        </div>

        <div v-else-if="field.type === 'select'">
          <base-input class="mb-0">
            <span class="form-control-label">
              {{ field.label }}
            </span>

            <el-select v-model="config[field.key]" :placeholder="field.label">
              <el-option v-for="(item, i) in field?.values" :key="i" :label="item?.label ?? undefined"
                :value="item?.value ?? undefined">
              </el-option>
            </el-select>
          </base-input>
        </div>

        <div v-else-if="field.type === 'multi_select_allow_create'">
          <base-input class="mb-0">
            <span class="form-control-label">
              {{ field.label }}
            </span>

            <el-select multiple filterable allow-create default-first-option v-model="config[field.key]" :placeholder="field.label">
              <el-option v-for="(item, i) in field?.values" :key="i" :label="item ?? undefined"
                :value="item ?? undefined">
              </el-option>
            </el-select>
          </base-input>
        </div>

        <base-input v-else v-model="config[field.key]" :type="field.type" :label="field.label" :disabled="isDisabled"
          :placeholder="field.label" class="mb-0" :rows="field.type === 'textarea' ? 4 : undefined" />

        <small v-if="field?.description ?? null" class="text-xs">
          {{ field.description }}
        </small>

        <!-- <validation-error :errors="apiValidationErrors.config[field.key]" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Row, Col, Card, Button } from "element-ui";
import alertLeave from "@/mixins/alert-leave-mixin";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseCheckbox from "@/components/Inputs/BaseCheckbox.vue";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";

export default {
  name: "ModuleAdditionalConfigForm",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Card.name]: Card,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    BaseInput,
    BaseCheckbox,
  },

  props: ["value", "serviceType", "title", "disabled", "fields"],

  mixins: [alertLeave, formMixin],

  data() {
    return {
      config: this.value || {},
      serviceFields: this.fields || {},
    };
  },

  computed: {
    isDisabled() {
      return this.disabled ?? false;
    },
  },

  watch: {
    value: {
      handler(newVal) {
        this.config = newVal ?? {};
        this.applyDefaultValues(); // Ensure defaults are applied when value changes 
      },
      deep: true,
      immediate: true,
    },
    config: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
    },
  },

  mounted() {
    this.applyDefaultValues();
  },

  methods: {
    applyDefaultValues() {
      this.fields?.forEach((field) => {
        // Appliquer une valeur par défaut si elle existe
        if (
          field?.default !== undefined &&
          this.config[field.key] === undefined
        ) {
          this.$set(this.config, field.key, field.default);
        }

        // Si c'est un champ select, vérifier si la valeur actuelle est encore valide
        if (field.type === 'select' && Array.isArray(field.values)) {
          const validValues = field.values.map((v) => v.value);
          if (!validValues.includes(this.config[field.key])) {
            this.$set(this.config, field.key, null); // ou undefined
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.form-wrapper {
  .form-group {
    .el-select {
      margin: 8px 0 0 0;
    }
  }
}
</style>
